import { render, staticRenderFns } from "./OfferArticlePage.vue?vue&type=template&id=67000b57&"
import script from "./OfferArticlePage.vue?vue&type=script&lang=js&"
export * from "./OfferArticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports